import React from 'react';
import {
  Image
} from 'antd';
import { DEFAULT_PROFILE_IMAGE } from '../../../../common/awsBucket';

const ShowLogo = ({ imageURL }) => {
  return (
    <div>
      {imageURL ? (
        <Image
          width={75}

          src={imageURL}
        />) : <Image
        width={75}
        src={DEFAULT_PROFILE_IMAGE}
      />}
    </div>
  )
};

export default ShowLogo;